export const environment = {
  name: 'Integration',
  production: true,
  enableTestAuth: true, // Enable test auth in integration for manual testing
  apiUrl: 'https://checkpoint.int.gardenbaysoftware.com/api',
  wsUrl: 'wss://checkpoint.int.gardenbaysoftware.com',
  artworkPath: 'artwork/integration',
  serviceWorkerScriptUrl: 'ngsw-worker.js?swv=20260308-1',
  showClickableQrUrls: true, // Enable clickable QR URLs for easier testing

  // Sync configuration
  syncConfig: {
    uploadIntervalMs: 5000,
    clockSyncIntervalMs: 300000, // 5 minutes
    maxReconnectAttempts: 10,
  },

  oauth: {
    google: {
      clientId: '170831075884-olg6jshvgfign7lobak7iq53rgjhmmdm.apps.googleusercontent.com',
      redirectUri: 'https://checkpoint.int.gardenbaysoftware.com/oauth-callback',
    },
  },
  permissions: {
    'feature.artwork-override': true, // Enabled in non-production
  },
};
